import { createSlice } from "@reduxjs/toolkit";
import { resetStateAction } from "../State/resetStateMiddleware";

const initialState = {
  //  fullName: null,
  sponsaUserName: null,
  token: null,
  userImg: null,
  password: null,
  email: null,
  accountType: null,
  displayName: null,
  bio: null,
  userId: null,
  api_key: null,
  uid: null,
  company: null,
  logoutTimer: null,
  YtUrl: null,
  TwitterUrl: null,
  InstaUrl: null,
  FbUrl: null,
  CoverIMG: null,
  stripeID: null,
  paypalID: null,
  role: null,
  IsGoogleAccount: null,
  GoogleID: null,
  stripeConnectedEmail: null,
  currency: null,
  isverified: false,
  paypalConnectedEmail: null,
  ryftSubAccountID: null,
  isAuthenticated: false,
  ReceiveAllTips: null,
  ReceiveGoalFunded: null,
  socialLinks: [],
  selectedTags: [],
  isYouTubeConnected: false,
  youtubeEmail: null,
  isTwitchConnected: false,
  twitchEmail: null,
  isTwitterConnected: false,
  twitterUsername: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,

  reducers: {
    // setSignUpdata: (state, action) => {
    //   //  state.fullName = action.payload.UserName;
    //   const email = action.payload.email;
    //   state.email = email;
    //   const password = action.payload.password;
    //   state.password = password;
    //   state.IsGoogleAccount = action.payload.IsGoogleAccount;
    //   state.GoogleID = action.payload.GoogleID;
    //   state.accountType = action.payload.accountType;
    //   state.sponsaUserName = action.payload.sponsaUserName;
    //   state.userImg = action.payload.userImg;
    //   state.displayName = action.payload.displayName;
    //   state.bio = action.payload.bio;
    // },
    setSignUpdata: (state, action) => {
      const p = action.payload || {};

      if (p.email !== undefined) state.email = p.email;
      if (p.password !== undefined) state.password = p.password;
      if (p.IsGoogleAccount !== undefined)
        state.IsGoogleAccount = p.IsGoogleAccount;
      if (p.GoogleID !== undefined) state.GoogleID = p.GoogleID;

      if (p.accountType !== undefined) state.accountType = p.accountType;
      if (p.sponsaUserName !== undefined)
        state.sponsaUserName = p.sponsaUserName;

      if (p.userImg !== undefined) state.userImg = p.userImg;

      if (p.displayName !== undefined) state.displayName = p.displayName;
      if (p.bio !== undefined) state.bio = p.bio;

      // If you later add more signup fields, follow the same pattern:
      // if (p.xyz !== undefined) state.xyz = p.xyz;
    },

    setAccountUpdateData: (state, action) => {
      state.sponsaUserName = action.payload.sponsaUserName;
      state.userImg = action.payload.userImg;
      state.displayName = action.payload.displayName;
      state.bio = action.payload.bio;
      state.YtUrl = action.payload.YtUrl;
      state.TwitterUrl = action.payload.TwitterUrl;
      state.InstaUrl = action.payload.InstaUrl;
      state.FbUrl = action.payload.FbUrl;
      state.CoverIMG = action.payload.CoverIMG;
      state.socialLinks = action.payload.socialLinks || [];
      state.selectedTags = action.payload.selectedTags || [];
    },
    setAccountType: (state, action) => {
      state.accountType = action.payload;
    },
    setCurrency: (state, action) => {
      state.currency = action.payload;
    },
    // setStripeID: (state, action) => {
    //   state.stripeID = action.payload.stripeID;
    //   state.stripeConnectionDate = action.payload.stripeConnectionDate;
    //   state.stripePublishableKey = action.payload.stripePublishableKey;
    // },
    setStripeID: (state, action) => {
      state.stripeID = action.payload.stripeID;
      state.stripeConnectionDate = action.payload.connectionDate;
      state.stripePublishableKey = action.payload.publishableKey;
      state.stripeConnectedEmail = action.payload.stripeConnectedEmail;
    },
    setYouTubeConnection: (state, action) => {
      state.isYouTubeConnected = action.payload.connected;
      state.youtubeEmail = action.payload.email;
    },
    setTwitchConnection: (state, action) => {
      state.isTwitchConnected = action.payload.connected;
      state.twitchEmail = action.payload.email;
    },
    setTwitterConnection: (state, action) => {
      state.isTwitterConnected = action.payload.connected;
      state.twitterUsername = action.payload.username;
    },
    resetStripeID: (state) => {
      state.stripeID = null;
      state.stripeConnectedEmail = null;
    },
    setPayPalID: (state, action) => {
      state.paypalID = action.payload.paypalID;
      state.paypalConnectedEmail = action.payload.paypalConnectedEmail;
    },
    setRyftID: (state, action) => {
      state.ryftSubAccountID = action.payload.ryftSubAccountID;
    },
    resetRyftID: (state) => {
      state.ryftSubAccountID = null;
    },
    resetPayPalID: (state) => {
      state.paypalID = null;
      state.paypalConnectedEmail = null;
    },
    setSignUpImg: (state, action) => {
      const userImg = action.payload.userImg;
      state.userImg = userImg;
    },

    setEmail: (state, action) => {
      state.email = action.payload.email;
    },
    setCoverImage: (state, action) => {
      state.CoverIMG = action.payload.CoverIMG;
    },
    setuid: (state, action) => {
      state.uid = action.payload.uid;
    },

    setLogin: (state, action) => {
      //  state.fullName = action.payload.username;
      state.email = action.payload.email;
      state.accountType = action.payload.accountType;
      state.sponsaUserName = action.payload.sponsaUserName;
      state.displayName = action.payload.displayName;
      state.uid = action.payload.uid;
      state.userImg = action.payload.userImg;
      state.YtUrl = action.payload.YtUrl;
      state.TwitterUrl = action.payload.TwitterUrl;
      state.InstaUrl = action.payload.InstaUrl;
      state.FbUrl = action.payload.FbUrl;
      state.CoverIMG = action.payload.CoverIMG;
      state.bio = action.payload.bio;
      state.stripeID = action.payload.stripeID;
      state.currency = action.payload.currency;
      state.isverified = action.payload.isverified;
      state.role = action.payload.role;
      state.paypalID = action.payload.paypalID;
      state.paypalConnectedEmail = action.payload.paypalConnectedEmail;
      state.isAuthenticated = true;
      state.ReceiveAllTips = action.payload.ReceiveAllTips;
      state.ReceiveGoalFunded = action.payload.ReceiveGoalFunded;
      state.socialLinks = action.payload.socialLinks || [];
      state.selectedTags = action.payload.selectedTags || [];
      state.isYouTubeConnected = action.payload.connected;
      state.youtubeEmail = action.payload.email;
      state.isTwitchConnected = action.payload.connected;
      state.twitchEmail = action.payload.email;
      state.isTwitterConnected = action.payload.connected;
      state.twitterUsername = action.payload.username;
    },

    setLogoutTimer: (state, action) => {
      // Update the logout timer in the state
      state.logoutTimer && clearTimeout(state.logoutTimer);
      state.logoutTimer = action.payload;
    },
    setNotificationPreferences: (state, action) => {
      if (action.payload.ReceiveAllTips !== undefined) {
        state.ReceiveAllTips = action.payload.ReceiveAllTips;
      }
      if (action.payload.ReceiveGoalFunded !== undefined) {
        state.ReceiveGoalFunded = action.payload.ReceiveGoalFunded;
      }
    },

    setLogOut: (state) => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSignUpdata,
  setSignUpImg,
  setLogin,
  setLogOut,
  setLogoutTimer,
  setEmail,
  setuid,
  setAccountUpdateData,
  setCoverImage,
  setAccountType,
  setStripeID,
  resetStripeID,
  setCurrency,
  setPayPalID,
  setRyftID,
  resetPayPalID,
  resetRyftID,
  setNotificationPreferences,
  setYouTubeConnection,
  setTwitchConnection,
  setTwitterConnection,
} = authSlice.actions;

export default authSlice.reducer;
export { resetStateAction };
